import { returnErrors } from './errorAction';
import { GET_USERS, GET_SUBSCRIPTION_PLANS, UPDATE_SUBSCRIPTION_PLANS, NO_USER_FOUND, GET_NEXT_USERS, RESET_USERS_LIST, ADD_USERS, UPDATE_STATUS, GET_TENANTS, GET_NEXT_TENANTS, GET_TENANTS_USER, UPDATE_TENANT_STATUS, ADD_CREDITS, GET_USER_SUBSCRIPTION_PLAN, CREATE_USER_SUBSCRIPTION } from '../Types/types';
import { getApiCall, handle403Logout, postApiCall, postApiCall2 } from '../../utils/request';
import { getJobApiCall, patchJobApiCall, postJobApiCall } from '../../utils/jobRequest';

export const getUsers = (query, page, rows) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/list-user?SearchText=${encodeURIComponent(query)}&PageNumber=${page}&DisplayRows=${rows}`);
        if (response.status === 200) {
            dispatch({ type: GET_USERS, payload: response.data })
        } else {
            dispatch({ type: NO_USER_FOUND, })
        }
    }
    catch (error) {
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
}

export const getNextUsers = (query, page, rows) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/list-user?SearchText=${encodeURIComponent(query)}&PageNumber=${page}&DisplayRows=${rows}`);
        if (response.status === 200) {
            dispatch({ type: GET_NEXT_USERS, payload: response.data })
        } else {
            dispatch({ type: NO_USER_FOUND, })
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
}

export const resetUserList = () => async (dispatch) => {
    return dispatch({ type: RESET_USERS_LIST })
}

export const addUser = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall2(`user/add-user`, obj);
        if (response.status === 200) {
            return dispatch({ type: ADD_USERS, payload: response.data })
        } else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.message, response?.status)
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error?.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

export const changeStatus = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/update-user-status`, obj);
        if (response.status === 200) {
            return dispatch({ type: UPDATE_STATUS, payload: obj })
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
}

export const getTenants = (query, page, rows) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/list-tenant?SearchText=${encodeURIComponent(query)}&PageNumber=${page}&DisplayRows=${rows}`);
        if (response.status === 200) {
            dispatch({ type: GET_TENANTS, payload: response.data })
        } else {
            // dispatch({ type: NO_USER_FOUND, })
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
}



export const getNextTenants = (query, page, rows) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/list-tenant?SearchText=${encodeURIComponent(query)}&PageNumber=${page}&DisplayRows=${rows}`);
        if (response.status === 200) {
            dispatch({ type: GET_NEXT_TENANTS, payload: response.data })
        } else {
            // dispatch({ type: NO_USER_FOUND, })
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Something went wrong', error?.response?.status);
    }
}

// Get Subscripionplan list
export const getUserSubscriptionPlan = () => async (dispatch) => {
    try {
        const response = await getApiCall(`setting/get-subscription-plans`);
        if (response.status === 200) {
            dispatch({ type: GET_SUBSCRIPTION_PLANS, payload: response.data })
        } else {
            // dispatch({ })
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

// Update Plan
export const updateSubscriptionPlan = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`setting/update-subscription-plan`, obj);
        if (response.status === 200) {
            return dispatch({ type: UPDATE_SUBSCRIPTION_PLANS, payload: response.data })
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

// Get Tenant Profile

export const getTenantsProfile = (TenantId, UserId) => async (dispatch) => {
    try {
        const response = await getApiCall(`user/tenant-user?TenantId=${TenantId}&UserId=${UserId}`);
        if (response.status === 200) {
            return dispatch({ type: GET_TENANTS_USER, payload: response.data })
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

// Update Tenant Status
export const updateTenantStatus = (obj) => async (dispatch) => {
    try {
        const response = await postApiCall(`user/update-user-status`, obj);
        if (response.status === 200) {
            return dispatch({ type: UPDATE_TENANT_STATUS, payload: response.data })
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}
// Update Tenant Credits
export const updateCredits = (payload) => async (dispatch) => {
    try {
        const response = await postApiCall("setting/add-additional-credit", payload);
        if (response.status === 200) {
            return dispatch({ type: ADD_CREDITS, payload: response.data });
        } else {
            returnErrors(dispatch, response?.data?.responseMessages[0]?.messagee, response?.status);
        }
    }
    catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
    }
}

//get subscription plans
export const getSubscriptionPlans = (TenantId) => async (dispatch) => {
  try {
    const response = await getJobApiCall(`subscription/tenant/${TenantId}`);
    dispatch({ type: GET_USER_SUBSCRIPTION_PLAN, payload: response.data });
    return response;
  } catch (error) {
    handle403Logout(error);
    console.error({
      status: error?.parsedStatus,
      message: error?.parsedMessage,
      error,
    });
    throw error;
  }
};


// Get all available plans for subscription
export const getAllSubscriptionPlanOptions = () => async (dispatch) => {
  try {
    const response = await getJobApiCall(`subscription-plan`);
    return response;
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};

//Creating Tenant Subscription
export const createTenantSubscription = (payload) => async (dispatch) => {
  try {
    const response = await postJobApiCall("subscription/", payload);
    dispatch({ type: CREATE_USER_SUBSCRIPTION, payload: response.data });
    return response;
  } catch (error) {
    handle403Logout(error);
    returnErrors(dispatch, error.response?.data?.responseMessages[0]?.message, error?.response?.status);
  }
};

export const updateCandidateCredits = (subscriptionId, payload) => async (dispatch) => {
    try {
        const response = await patchJobApiCall(`subscription/${subscriptionId}/feature-counts`, payload);
        return response;
    } catch (error) {
        handle403Logout(error);
        returnErrors(dispatch, 'Failed to update candidate credits', error?.response?.status);
    }
};
